import StickyHeader from "components/utility/sticky-header/StickyHeader";
import StickyHeaderContainer from "components/utility/sticky-header/StickyHeaderContainer";

const InsightsTabLoader = () => {
	return (
		<StickyHeaderContainer>
			<StickyHeader>
				<section className="insights-browse-bar-container container placeholder">
					<div className="grid-12 insights-browse-bar-desktop">
						<div className="insights-browse-bar-tabs">
							<div className="insights-browse-bar-tab">
								<p className="placeholder-pulse"></p>
							</div>
							<div className="insights-browse-bar-tab">
								<p className="placeholder-pulse"></p>
							</div>
							<div className="insights-browse-bar-tab">
								<p className="placeholder-pulse"></p>
							</div>
							<div className="insights-browse-bar-tab">
								<p className="placeholder-pulse"></p>
							</div>
						</div>
						<div className="insights-browse-options-container">
							<div className="insights-browse-options-list">
								<p className="placeholder-pulse"></p>
							</div>
							<div className="insights-browse-options-list">
								<p className="placeholder-pulse"></p>
							</div>
						</div>

						<div className="insights-browse-bar-divider"></div>
					</div>
					<div className="insights-browse-bar-mobile">
						<div className="insights-browse-bar-mobile-dropdown" style={{ pointerEvents: "none" }}>
							All
						</div>
						<div className="insights-browse-bar-mobile-header">
							<p className="placeholder-pulse">Placeholder</p>
							<div className="insights-browse-bar-mobile-filter">
								<div className="insights-browse-bar-mobile-filter-counter"></div>
							</div>
						</div>
					</div>
				</section>
			</StickyHeader>
		</StickyHeaderContainer>
	);
};

export default InsightsTabLoader;
